/**
 * profileStorage — legacy single-profile storage.
 * @deprecated Use childrenStorage for all new code. This module is only used
 * for guest migration: detecting whether a user had a profile before accounts
 * were introduced, so it can be offered as import data.
 */

import type { ChildProfile } from '../types'

const STORAGE_KEY = 'energymatch-profile'

function isValidLegacyProfile(obj: unknown): obj is Omit<ChildProfile, 'id'> {
  if (!obj || typeof obj !== 'object') return false
  const p = obj as Record<string, unknown>
  if (typeof p.firstName !== 'string') return false
  if (typeof p.age !== 'string') return false
  if (p.sex !== '' && p.sex !== 'male' && p.sex !== 'female') return false
  if (typeof p.weightKg !== 'string') return false
  if (!Array.isArray(p.dietaryRequirements)) return false
  if (p.dietaryRequirements.some((x) => typeof x !== 'string')) return false
  if (typeof p.dietaryOther !== 'string') return false
  return true
}

/**
 * Read the legacy single-profile from localStorage.
 * Returns null if no legacy profile exists.
 * Used only for guest migration — returns profile without an id field.
 */
export function getStoredProfile(): Omit<ChildProfile, 'id'> | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as unknown
    return isValidLegacyProfile(parsed) ? parsed : null
  } catch {
    return null
  }
}

/** Clear the legacy profile after migration. */
export function clearLegacyProfile(): void {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
